import React from 'react';
import classNames from 'classnames';
import styles from './styles.scss';
import { priceMap, formatPrice } from 'Utils';

type Props = {
  value: string,
  prefix?: string,
  currency?: string,
  subline?: string,
  small?: boolean,
  dark?: boolean,
  light?: boolean,
  showZero?: boolean,
};

export default class Price extends React.Component<Props> {
  static defaultProps = {
    currency: '€',
    dark: false,
  };

  render() {
    const { value, prefix, currency, subline, small, dark, light, showZero } = this.props;
    const [euro, cent] = value.replace(' €', '').split(',');
    // due different prefix types of teaser and service prefix has to be possibly its value
    const _prefix = prefix ? (prefix.value ? prefix.value : prefix) : '';
    const _euro = formatPrice(euro.replace(/\./g, ''));

    return (
      <div className={styles.priceWrapper}>
        <div
          className={classNames(styles.price, {
            [styles.small]: small,
            [styles.dark]: dark,
            [styles.light]: light,
          })}
        >
          {_prefix && <span className={styles.prefix}>{priceMap.get(_prefix)}</span>}
          {_prefix !== 'FREE' && _prefix !== 'INCLUDED' && (
            <React.Fragment>
              <span className={styles.value}>
                {_euro.slice(0, _euro.indexOf(','))}
                {cent && (
                  <span>
                    {cent !== '00' || showZero ? ',' : ' '}
                    {showZero && cent === '00' && <sup>{cent}</sup>}
                    {cent !== '00' && <sup>{cent}</sup>}
                  </span>
                )}
              </span>
              {currency && (
                <span className={styles.currency}>
                  <sup>{currency}</sup>
                </span>
              )}
            </React.Fragment>
          )}
        </div>
        {subline && <div className={styles.subline}>{subline}</div>}
      </div>
    );
  }
}
